import { render, staticRenderFns } from "./TabellaCustom.vue?vue&type=template&id=cd310d60&scoped=true&"
import script from "./TabellaCustom.vue?vue&type=script&lang=js&"
export * from "./TabellaCustom.vue?vue&type=script&lang=js&"
import style0 from "./TabellaCustom.vue?vue&type=style&index=0&id=cd310d60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd310d60",
  null
  
)

export default component.exports